
const ButtonIcon = (props: any) => {

  let icon = props.icon ?? '';
  let active = props.active ?? false;
  let disabled = props.disabled ?? false;
  let title = props.title ?? "";
  let className = props.className ?? "";
  return (
    <div className={`d-inline ${className}`} title={title}>
      <button disabled={disabled} className={`btn btnIcon  ${active ? "active" : ""}`} onClick={props.handleClick}>
        <span className="material-symbols-outlined">
          {icon}
        </span>


      </button >
    </div>
  )
}

export default ButtonIcon;
